import { render } from "./EmployeeWorkExperience.vue?vue&type=template&id=5a174817"
import script from "./EmployeeWorkExperience.vue?vue&type=script&lang=js"
export * from "./EmployeeWorkExperience.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__